import axios from 'axios'
import Footer from 'components/layout/Footer'
import MainMenu from 'components/layout/MainMenu'
import TopMenuBar from 'components/layout/TopMenuBar'
import Env from 'Env'
import HTTPMethod from 'http-method-enum'
import Markdown from 'markdown-to-jsx'
import { GetStaticProps } from 'next'
import Head from 'next/head'
import React, { Fragment } from 'react'
import { Converters } from 'services/Converters'

type Props = {
  page: any
  menu: any
  footer: any
}

export default function DidntReceiveVerificationEmailPage(props: Props) {
  const attr = props.page.data.attributes
  return (
    <Fragment>
      <Head>
        <title>{attr.title}</title>
      </Head>
      <TopMenuBar noTopPadding />
      <MainMenu menu={props.menu} isStatic />
      <section className="receive-verification-email lg:pt-[215px] pt-[40px] font-lato">
        <div className="container">
          <div className="flex flex-wrap lg:px-[185px] px-[30px]">
            <div className="w-full">
              <h3 id="got-it-we-have-resent-the-verification-email" className="text-center font-bold md:text-3xl text-2xl text-[#000000] pb-[0px]">
                {attr.title}
              </h3>
              <h5 id="toc-anchor-">&nbsp;</h5>
              <h5 id="if-it-still-doesnt-arrive-within-a-few-minutes-here-are-some-things-that-may-help" className="text-base text-[#333333] font-semibold text-center">
                <strong>{attr.subtitle}</strong>
              </h5>
              <div className="custom-list-style">
                <Markdown>{attr.richText}</Markdown>
              </div>
            </div>
            <div className="w-full text-center text-lg font-medium border-t border-gray-100 my-[60px] pt-[30px]">
              <h3 id="still-no-luck" className="text-3xl font-medium text-black">
                {attr.secondTitle}
              </h3>
              <Markdown>{attr.richSubText}</Markdown>
            </div>
          </div>
        </div>
      </section>
      <Footer data={props.footer} />
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const page = await axios({
    method: HTTPMethod.GET,
    baseURL: Env.ApiUrl,
    url: '/didnt-receive-verification-email-page',
  }).then((resp) => Converters.KeysConvert.ToLowerCase(resp.data))

  const menu = await axios({
    method: HTTPMethod.GET,
    baseURL: Env.ApiUrl,
    url: '/menus/1',
    params: { populate: 'deep' },
  }).then((resp) => Converters.KeysConvert.ToLowerCase(resp.data))

  const footer = await axios({
    method: HTTPMethod.GET,
    baseURL: Env.ApiUrl,
    url: '/menus/2',
    params: { populate: 'deep' },
  }).then((resp) => Converters.KeysConvert.ToLowerCase(resp.data))

  return { props: { page, menu, footer }, revalidate: Env.PropsRevalidateTime }
}
